export default __webpack_public_path__ + "static/media/8.24765ad8.png";